<template>
  <div class="privacy-policy">
    <h1>Política de privacidad</h1>
    <section>
      <h2>Introducción</h2>
      <p>
        La presente Política de privacidad resume las prácticas llevadas a cabo por Geobizi ("nosotros", "nuestro" o "la
        Empresa") en relación a la información recopilada de los usuarios que acceden a nuestro sitio web a través de
        www.geobizi.com ("Sitio"), o que comparten información personal con nosotros (de forma conjunta, "Usuarios").
      </p>
      <p>
        La autoridad responsable con arreglo a las leyes de protección de datos, en concreto, el Reglamento general de
        protección de datos (GDPR, por sus siglas en inglés): Reglamento (UE) 2016/679 del Parlamento Europeo y del
        Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al
        tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva
        95/46/CE; El Real Decreto 1720/2007, de 21 de diciembre, por el que se aprueba el Reglamento de desarrollo de la
        Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal; La Ley 34/2002, de 11 de
        julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE) y la Ley Orgánica
        3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales.
      </p>
    </section>
    <section>
      <h2>Derechos del usuario</h2>
      <p>Puede solicitar:</p>
      <ul>
        <li>Recibir confirmación de si se está procesando o no información personal sobre usted, además de acceso a su
          información personal almacenada, junto con información complementaria.</li>
        <li>Recibir en un formato estructurado, de uso general y de lectura mecanizada una copia de la información
          personal que nos ofrece directamente.</li>
        <li>Solicitar la rectificación de su información personal de la cual tenemos control.</li>
        <li>Solicitar el borrado de su información personal.</li>
        <li>Oponerse al procesamiento por nuestra parte de su información personal.</li>
        <li>Solicitar la restricción del procesamiento por nuestra parte de su información personal.</li>
        <li>Presentar una denuncia o reclamación a una autoridad supervisora.</li>
      </ul>
      <p>
        No obstante, tenga en cuenta que estos derechos no son definitivos y pueden estar sujetos a nuestros propios
        intereses legítimos y requisitos normativos.
      </p>
      <p>
        Si desea ejercer cualquier de los derechos mencionados anteriormente, o bien recibir más información, pónganse
        en contacto con nuestro Director de Protección de Datos ("DPO") mandando un mensaje a geobizi@hotmail.com.
      </p>
    </section>
    <section>
      <h2>Retención de datos</h2>
      <p>
        Retendremos su información personal el tiempo que resulte necesario para proporcionar nuestros servicios, así
        como para cumplir nuestras obligaciones legales, resolver disputas e implementar y hacer cumplir nuestras
        políticas. Los periodos de retención se determinarán teniendo en cuenta el tipo de información recopilada y el
        fin de dicha recopilación, teniendo en cuenta los requisitos aplicables a la situación y la necesidad de
        destruir en el menor tiempo posible la información obsoleta y sin utilizar. En virtud de las legislaciones
        aplicables, conservaremos registros que contengan información personal de los clientes, documentos de apertura
        de cuentas, comunicaciones y cualquier otro tipo de información requerida por las leyes y normativas aplicables.
      </p>
      <p>
        Podemos rectificar, reponer o eliminar la información que no sea precisa, en cualquier momento y según nuestro
        propio criterio.
      </p>
    </section>
    <section>
      <h2>Motivos para la recopilación de datos</h2>
      <p>
        El procesamiento de su información personal (es decir, cualquier información que pueda permitir su
        identificación mediante medios razonables; (en lo sucesivo "Información personal") es necesario para el
        cumplimiento de nuestras obligaciones contractuales con usted, además de para proporcionarle nuestros servicios,
        proteger nuestros intereses legítimos y cumplir con las legislaciones legales y financieras a las que estamos
        sujetos.
      </p>
      <p>
        Al utilizar el Sitio, da su consentimiento a la recopilación, el almacenamiento, la utilización, la divulgación
        y otros usos de su información personal, tal y como se describe en la presente Política de Privacidad.
      </p>
      <p>
        Recomendamos a nuestros Usuarios que lean detenidamente la presente Política de Privacidad y que hagan uso de
        ella para la toma de decisiones fundamentadas.
      </p>
    </section>
    <section>
      <h2>¿Qué información recopilamos?</h2>
      <p>
        Recopilamos dos tipos de datos e información de los Usuarios.
      </p>
      <p>
        El primer tipo se corresponde con información sin identificar y no identificable perteneciente a los Usuarios,
        la cual puede recopilarse a través del uso que hace del Sitio ("Información no personal"). Desconocemos la
        identidad de un Usuario cuya información no personal recopilamos. Esta información puede incluir datos de uso
        acumulados e información técnica transmitida por el dispositivo, tanto de software como de hardware (como, por
        ejemplo, el tipo de navegador y el sistema operativo que utiliza el dispositivo, las preferencias de idioma, la
        hora de acceso, etc.), a fin de mejorar la funcionalidad de nuestro Sitio. Asimismo, también recopilamos
        información acerca de su actividad en él (como páginas visitadas, navegación web, clics, acciones, etc.).
      </p>
      <p>
        El segundo tipo de información es la Información personal que es la información individualmente identificable,
        es decir, la información que identifica a una persona o que puede, sin excesiva dificultad, identificar a una
        persona. En esta información, se incluye:
      </p>
      <ul>
        <li>Información del dispositivo: recopilamos información personal procedente del dispositivo. Dicha información
          incluye datos de geolocalización, dirección IP, identificadores exclusivos (como direcciones MAC y UUID) y
          otra información relacionada con su actividad en el Sitio.</li>
        <li>Información sobre el registro: cuando se registre en nuestro Sitio, se le pedirá que nos proporcione
          determinados datos, como su nombre y apellidos, su dirección de correo electrónico o postal y cualquier otra
          información que sea relevante para el servicio o su mejora.</li>
      </ul>
    </section>
    <section>
      <h2>¿Cómo recibimos la información sobre usted?</h2>
      <p>Recibimos su información personal a raíz de diversas acciones u orígenes:</p>
      <ul>
        <li>Cuando voluntariamente nos proporciona sus datos personales al registrarse en nuestro Sitio.</li>
        <li>Cuando utiliza nuestro Sitio o hace uso de él en relación con el uso que hace de nuestros servicios.</li>
        <li>A partir de proveedores, servicios y registros públicos externos (como por ejemplo proveedores de
          estadísticas sobre el tráfico).</li>
      </ul>
    </section>
    <section>
      <h2>¿Cómo se utiliza la información? ¿Con quién compartimos la información?</h2>
      <p>
        No alquilamos, vendemos o compartimos la información de los Usuarios con ninguna tercera parte salvo en los
        términos descritos en la presente Política de Privacidad.
      </p>
      <p>
        Podemos hacer uso de la información con los siguientes fines:
      </p>
      <ul>
        <li>Mantener comunicación con usted: para enviarle notificaciones relacionadas con nuestros servicios,
          proporcionándole información técnica y solucionando cualquier problema de servicio al cliente que pueda tener.
        </li>
        <li>Comunicarse con usted y mantenerle informado acerca de nuestros servicios y actualizaciones más recientes.
        </li>
        <li>Comercializar y promocionar nuestros sitios web y productos.</li>
        <li>Llevar a cabo pruebas y estudios estadísticos y analíticos con el fin de mejorar el Sitio.</li>
      </ul>
      <p>
        Además de los diferentes usos enumerados anteriormente, puede que transfiramos o divulguemos información
        personal a nuestras empresas filiales y subcontratistas, como puede ser la asesoría fiscal para poder realizar
        la facturación si es necesario.
      </p>
      <p>
        Aparte de los fines enumerados en la presente Política de privacidad, podemos compartir la información personal
        con nuestros proveedores externos de confianza, los cuales pueden estar ubicados en diferentes jurisdicciones de
        todo el mundo, para cualquiera de los siguientes fines:
      </p>
      <ul>
        <li>Alojar y gestionar nuestro Sitio web.</li>
        <li>Ofrecerle nuestros servicios, incluida una visualización personalizada de nuestro Sitio web.</li>
        <li>Almacenar y procesar dicha información en nuestro nombre.</li>
        <li>Ofrecerle anuncios y ayudarle tanto en la evaluación del éxito de nuestras campañas publicitarias como en la
          reorientación de cualquiera de nuestros usuarios.</li>
        <li>Proporcionarle ofertas comerciales y material promocional relacionado con nuestro Sitio web y nuestros
          servicios.</li>
        <li>Realizar investigaciones, diagnósticos técnicos o análisis.</li>
      </ul>
      <p>
        Además, es posible que divulguemos información si creemos de buena fe que dicha divulgación resulta útil o
        razonablemente necesaria para: (i) cumplir con cualquier legislación, regulación, proceso legal o solicitud
        gubernamental aplicable; (ii) hacer cumplir nuestras políticas (incluida nuestra Política de privacidad), así
        como para investigar cualquier posible infracción de la misma; (iii) detectar, prevenir o abordar de algún otro
        modo el fraude, los problemas de seguridad o cualquier incidencia técnica; (iv) hacer frente a cualquier
        vulneración de las garantías contenidas en las reclamaciones de los usuarios, o proteger contra los perjuicios
        los derechos, la propiedad o la seguridad de Geobizi, de nuestros usuarios o de cualquier tercero; o (v)
        cooperar con los organismos de seguridad y/o, si lo consideramos necesario, ejercer nuestros derechos o
        responder a cualquier reclamación en nuestra contra.
      </p>
    </section>
    <section>
      <h2>Tratamiento de datos en actividades municipales (Zalla Natura y otros)</h2>
      <p>
        En las actividades realizadas en colaboración con entidades públicas (como el Ayuntamiento de Zalla), los datos
        de carácter personal solicitados tienen como finalidad exclusiva la organización, gestión de seguros y
        comunicación directa relacionada con la actividad concreta inscrita.
      </p>
      <p>
        Geobizi garantiza que estos datos no serán incorporados a bases de datos de marketing general ni cedidos a
        terceros, salvo obligación legal o autorización expresa del usuario mediante los mecanismos de consentimiento
        (checkboxes) habilitados en el formulario de inscripción.
      </p>
    </section>
    <section>
      <h2>Cookies</h2>
      <p>
        Nosotros y nuestros socios de confianza utilizamos cookies y otras tecnologías en nuestros servicios
        relacionados, incluidas cuando usted visita nuestro Sitio web o accede a nuestros servicios.
      </p>
      <p>
        Una "cookie" es un pequeño archivo de información que un sitio web asigna a su dispositivo mientras usted lo
        está viendo. Las cookies son muy útiles y se pueden utilizar para diferentes fines. Estos incluyen permitirle
        navegar entre páginas de forma eficiente, permitir la activación automática de determinadas funciones, recordar
        sus preferencias y hacer que la interacción entre usted y nuestros Servicios sea más rápida y sencilla. Las
        cookies también se utilizan para ayudar a garantizar que los anuncios que vea sean relevantes para usted y sus
        intereses, y para compilar datos estadísticos sobre el uso de nuestros servicios.
      </p>
      <p>
        El Sitio utiliza los siguientes tipos de cookies:
      </p>
      <ul>
        <li><strong>Cookies de sesión:</strong> Se almacenan temporalmente durante una sesión de navegación para
          permitir el uso normal del sistema y se eliminan de su dispositivo cuando se cierra el navegador.</li>
        <li><strong>Cookies persistentes:</strong> Solo son leídas por el Sitio, se guardan en su ordenador durante un
          periodo fijo y no se eliminan cuando se cierra el navegador. Dichas cookies se utilizan cuando necesitamos
          saber quién es usted para visitas repetidas, por ejemplo, para permitirnos almacenar sus preferencias para la
          siguiente vez que inicie sesión.</li>
        <li><strong>Cookies de terceros:</strong> Colocadas por otros servicios en línea que gestionan contenido en la
          página que está viendo, por ejemplo, por compañías de análisis de datos que monitorean y analizan nuestro
          acceso web.</li>
      </ul>
      <p>
        Las cookies no contienen ninguna información que lo identifique personalmente, pero podemos vincular la
        información personal que almacenamos a su información obtenida a partir de las cookies. Puede eliminar las
        cookies siguiendo las instrucciones en las preferencias del dispositivo; sin embargo, si elige desactivar las
        cookies, es posible que algunas funciones de nuestro Sitio no funcionen correctamente y su experiencia en línea
        puede ser limitada.
      </p>
    </section>
    <section>
      <h2>Uso de bibliotecas de scripts (Google Fonts)</h2>
      <p>
        Para presentar nuestro contenido correctamente y de manera visualmente atractiva en todos los navegadores,
        utilizamos bibliotecas de scripts y fuentes como Google Fonts (https://fonts.google.com/). Las fuentes de Google
        se transfieren a la memoria caché de su navegador para evitar la carga múltiple. Si el navegador no es
        compatible con Google Fonts o impide el acceso, el contenido se mostrará en una fuente predeterminada.
      </p>
      <p>
        Cuando llama a bibliotecas de scripts o fuentes, establece automáticamente una conexión con el operador de la
        biblioteca. Es teóricamente posible (aunque no está claro si y, en caso afirmativo, con qué fines) que los
        operadores de dichas bibliotecas recopilen datos.
      </p>
      <p>
        Puede encontrar la política de privacidad del operador de la biblioteca Google aquí:
        https://www.google.com/policies/privacy/.
      </p>
    </section>
    <section>
      <h2>Recopilación de datos por terceros</h2>
      <p>
        Nuestra política solo aborda el uso y la divulgación de la información que recopilamos de usted. En la medida en
        que divulgue su información a otras partes o sitios en Internet, pueden aplicarse diferentes reglas a su uso o
        divulgación de la información que les revele. En consecuencia, le animamos a leer los términos y condiciones y
        la política de privacidad de cada parte a la que elija divulgar información.
      </p>
      <p>
        Esta Política de privacidad no se aplica a las prácticas de empresas que no poseemos ni controlamos, ni a
        personas que no empleamos ni gestionamos, incluidas las terceras partes a las que podamos divulgar información
        como se establece en esta Política de privacidad.
      </p>
    </section>
    <section>
      <h2>¿Cómo protegemos su información?</h2>
      <p>
        Prestamos gran atención a la implementación y el mantenimiento de la seguridad de nuestro Sitio y su
        información. Empleamos procedimientos estándar del sector para garantizar la seguridad de la información que
        recopilamos y mantenemos, impidiendo el uso no autorizado de la misma. No obstante, no podemos garantizar la
        eliminación total de riesgos ni la completa seguridad absoluta.
      </p>
    </section>
    <section>
      <h2>Transferencia de datos fuera del Espacio Económico Europeo</h2>
      <p>
        Tenga en cuenta que algunos destinatarios de datos pueden estar ubicados fuera del Espacio Económico Europeo
        (EEE). En dichos casos, solo transferiremos sus datos a países aprobados por la Comisión Europea que
        proporcionan un nivel adecuado de protección de datos, o bien, estableceremos acuerdos legales para garantizar
        un nivel adecuado de protección de datos.
      </p>
    </section>
    <section>
      <h2>Anuncios</h2>
      <p>
        Es posible que también usemos un servicio de publicidad de terceros para publicar anuncios cuando acceda al
        Sitio. Dichos servicios pueden utilizar información sobre sus visitas a este Sitio y otros sitios web para
        proporcionar anuncios relevantes sobre bienes y servicios en los que pueda estar interesado. Para obtener más
        información sobre esto y conocer sus opciones respecto a no tener esta información utilizada por estas empresas,
        haga clic aquí: http://www.networkadvertising.org.
      </p>
    </section>
    <section>
      <h2>Marketing</h2>
      <p>
        Es posible que utilicemos su información personal, como su nombre, dirección de correo electrónico, número de
        teléfono, etc., nosotros mismos o bien utilizando nuestros subcontratistas externos para proporcionarle
        materiales promocionales relativos a nuestros servicios que, a nuestro juicio, puedan interesarle.
      </p>
      <p>
        Por respeto a su derecho a la privacidad, dentro de dichos materiales promocionales se incluyen los medios para
        rechazar la recepción de nuestras ofertas comerciales. Si cancela su suscripción, eliminaremos su dirección de
        correo electrónico o su número de teléfono de nuestras listas de distribución de marketing.
      </p>
      <p>
        Tenga en cuenta que incluso si ha cancelado su suscripción a la recepción de correos electrónicos de marketing
        nuestros, podremos enviarle otros tipos de comunicaciones importantes de servicios, de los cuales no puede
        excluirse la recepción.
      </p>
    </section>
    <section>
      <h2>Actualizaciones o cambios a la Política de privacidad</h2>
      <p>
        Nos reservamos el derecho de modificar o revisar periódicamente la Política de privacidad; los cambios
        materiales serán efectivos inmediatamente después de la visualización de la Política de privacidad revisada. La
        última revisión se reflejará en la sección "Última modificación". Su uso continuado de la Plataforma, tras la
        notificación de dichos cambios en nuestro sitio web, constituye su reconocimiento y consentimiento de dichos
        cambios en la Política de privacidad y su acuerdo de estar sujeto a los términos de dichos cambios.
      </p>
    </section>
    <section>
      <h2>Cómo contactarnos</h2>
      <p>
        Si tiene preguntas generales sobre el Sitio o la información que recopilamos sobre usted, o bien, sobre el uso
        que hacemos de dicha información, puede ponerse en contacto con nosotros en geobizi@hotmail.com.
      </p>
    </section>
  </div>
</template>

<script setup>
</script>

<style scoped>
.privacy-policy {
  padding-top: 7rem;
  max-width: 800px;
  margin: 0 auto;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 2rem;
  font-family: Arial, sans-serif;
  color: var(--darkgrey);
  line-height: 1.6;
}

h1,
h2 {
  color: var(--darkgreen);
}

ul {
  list-style-type: disc;
  margin-left: 2rem;
}

ul li {
  margin-bottom: 0.5rem;
}
</style>